module.exports = __webpack_public_path__ + "img/detail-ticket.eb9af9b8.svg";